import { Row } from "@tanstack/react-table";
import { ResourceExplorerGridDataWithId } from "@/store/resource-explorer/utils/types/resourceExplorerDataGrid";

const sort = (current: string, next: string) => {
  if (current > next) {
    return -1;
  }
  if (current < next) {
    return 1;
  }
  return 0;
};

export const labelColumnSortingFn = (
  currentRow: Row<ResourceExplorerGridDataWithId>,
  nextRow: Row<ResourceExplorerGridDataWithId>,
) => {
  const current = currentRow.original.label || currentRow.original.field;
  const next = nextRow.original.label || nextRow.original.field;

  return sort(current, next);
};
